import { Alert, Button, Stack, Text } from "@softmax/design-system";
import * as stylex from "@stylexjs/stylex";
import type { RefObject } from "react";
import type { CredentialDialogState } from "./credential-state";
import { credentialDialogStyles as styles } from "./credential-dialog.styles";

export function CredentialSecret({
  state,
  disabled,
  copyButton,
  onClose,
  onCopy,
}: {
  readonly state: Extract<CredentialDialogState, { readonly kind: "secret" }>;
  readonly disabled: boolean;
  readonly copyButton: RefObject<HTMLButtonElement | null>;
  readonly onClose: () => void;
  readonly onCopy: () => void;
}) {
  return (
    <div className="ph-no-capture" data-dd-privacy="hidden">
      <Stack width="auto">
        <Alert announcement="polite">
          Credential created. Copy it now; it will not be shown again.
        </Alert>
        <Text as="p" size="small" tone="muted">
          Treat this token as a password. Closing this dialog clears it.
        </Text>
        <pre aria-label="New credential token" {...stylex.props(styles.token)}>
          {disabled ? "Verify your account to reveal this token." : state.token}
        </pre>
        {state.copyError ? (
          <Alert tone="danger">{state.copyError}</Alert>
        ) : null}
        <div {...stylex.props(styles.actions)}>
          <Button onClick={onClose}>Done</Button>
          <Button
            ref={copyButton}
            variant="primary"
            disabled={disabled}
            onClick={onCopy}
          >
            {state.copied ? "Copied" : "Copy token"}
          </Button>
        </div>
      </Stack>
    </div>
  );
}
